import * as React from "react"

import { Route, Routes } from "react-router-dom"
import { Box } from "@mui/material"
import PageNotFound from "./components/PageNotFound"
import { Header } from "./components/Header"
import { Footer } from "./components/Footer"
import InputForm from "./components/InputForm"
import { ThanksPage } from "./components/ThanksPage"
import RequestBase from "./components/RequestBase"
import Confirm from "./components/Confirm"


const App = () => {
  return (
    <Box display={"flex"} flexDirection={"column"} flexWrap={"nowrap"} height={"98vh"}>
      <Header flex={0} />
      <Box flex={1} height={"2000px"} overflow={"auto"} paddingTop={5}>
        <Routes>

          <Route path='/' element={< RequestBase />} >
            <Route path="/input" element={< InputForm />} />
            <Route path="/confirm" element={< Confirm />} />
            <Route path="/complete" element={< ThanksPage />} />
          </Route>

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Box>
      <Footer flex={0} />
    </Box>
  )
}

export default App